import { ApiRequest, ApiResponse, ApiResult } from '..';

export default abstract class ApiClient {
    // TODO remove ResponseType, use generic TResponseBody instead
    abstract execute<TRequest extends ApiRequest, TResponse extends ApiResponse>
        (request: TRequest, ResponseType?: { new(json: any): TResponse; }): Promise<ApiResult<TResponse>>;
}